// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1PMqC","colCheckbox":"styles_colCheckbox__33iMt"};